import { Button, Heading, Input, InputGroup, InputLeftAddon, Modal, ModalBody, ModalCloseButton, ModalHeader, ModalOverlay, Table, TableContainer, Tbody, Td, Th, Thead, Tr, ModalContent } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { createAnualidad, deleteAnualidad, getAnualidades, updateAnualidad } from "../../services/anualidad";
import Pagination from "../util/pagination/pagination";
import Select from 'react-select';
import InfoModal from "../util/confirmModal/InfoModal";
import ConfirmModal from "../util/confirmModal/confirmModal";
import { t } from "i18next";
import { useTranslation } from "react-i18next";


const Anualidad = () => {

    const { t } = useTranslation();

    const defaultInfoModal = {
        title: "",
        message: "",
        isOpen: false,
        isError: false,
        callback: null,
    }
    const [infoModal, setInfoModal] = useState(defaultInfoModal);

    const defaultConfirmModal = {
        title: "",
        message: "",
        isOpen: false,
        onConfirm: null,
        onClose: null,
        isLoading: false,
        id: null,
    }

    const [confirmModal, setConfirmModal] = useState(defaultConfirmModal);

    const [anualidades, setAnualidades] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    // NEW ANUALIDAD DATA
    const [createModal, setCreateModal] = useState(false);

    const [idYear, setIdYear] = useState("");
    const [dateCharge, setDateCharge] = useState("");
    const [year, setYear] = useState("");
    const [monto, setMonto] = useState("");
    const [tipoCabana, setTipoCabana] = useState({ value: 'BAMBU', label: t('BAMBU') });

    const [dateChargeError, setDateChargeError] = useState(null);
    const [montoError, setMontoError] = useState(null);

    const tipoCabanaList = [
        { value: 'BAMBU', label: t('BAMBU') },
        { value: 'MEZQUITE', label: t('MEZQUITE') },
        { value: 'PIRUL', label: t('PIRUL') },
    ]



    const requestAnualidades = async () => {
        setLoading(true);
        try{
            const response = await getAnualidades(page);
            setAnualidades(response.data.anualidades);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.error("Error fetching anualidades", error);
        } finally {
            setLoading(false);
        }

    }

    const handleCloseModal = () => {
        setCreateModal(false);
        setIdYear("");
        setYear("");
        setMonto("");
        setTipoCabana({ value: 'BAMBU', label: t('BAMBU') });
    }

    const checkInput = {
        dateCharge: async () => {
            if (!dateCharge) {
                setDateChargeError(t('DATE_REQUIRED'));
                return false;
            }
            setDateChargeError(null);
            return true;
        },
        monto: async () => {
            if (!monto) {
                setMontoError(t('AMOUNT_REQUIRED'));
                return false;
            }
            if (isNaN(monto)) {
                setMontoError(t('AMOUNT_MUST_BE_NUMBER'));
                return false;
            }
            if (parseFloat(monto) <= 0) {
                setMontoError(t('AMOUNT_GREATER_THAN_ZERO'));
                return false;
            }
            setMontoError(null);
            return true;
        },
        checkAll: async (skip=[]) =>{
            let result = true
            for(const key in checkInput){
                if(key === "checkAll" || skip.findIndex(itm => itm === key) !== -1){
                    continue
                }
                const response = await checkInput[key]()
                if(result && !response){
                    result = false
                }
            }
            return result
        }
    }

    const requestCreateAnualidad = async () => {
        const isValid = await checkInput.checkAll();
        if (!isValid) return;

        setLoading(true);
        try {
            const response = await createAnualidad({
                date: (new Date(dateCharge.replace(/-/g, '/'))).toISOString(),
                monto,
                tipo: tipoCabana.value,
            });
            if (response.status === 200) {
                handleCloseModal();
                requestAnualidades();
            }
        } catch (error) {
            const message = error.response && error.response.data && error.response.data.msg ? error.response.data.msg : "Error creando la anualidad";
            setInfoModal({
                ...infoModal,
                title: "Error",
                message: message,
                isOpen: true,
                isError: true,
                callback: null,
            });
        } finally {
            setLoading(false);
        }
    }

    const requestUpdateAnualidad = async () => {
        const isValid = await checkInput.checkAll();
        if(!idYear || !isValid){
            return
        }
        setLoading(true);

        try {
            const response = await updateAnualidad({
                idAnualidad: idYear,
                date: (new Date(dateCharge.replace(/-/g, '/'))).toISOString(),
                monto,
                tipo: tipoCabana.value,
            })
            if (response.status === 200) {
                handleCloseModal();
                requestAnualidades();
                setInfoModal({
                    ...infoModal,
                    title: t('SUCCESS'),
                    message: t('SUCCESS_UPDATE_ANNUALITY'),
                    isOpen: true,
                    isError: false,
                    callback: null,
                });
            }
        } catch (error) {
            const message = error.response && error.response.data && error.response.data.msg ? error.response.data.msg : "Error actualizando la anualidad";
            setInfoModal({
                ...infoModal,
                title: t('ERROR'),
                message: t('ERROR_CREATING_ANNUALITY'),
                isOpen: true,
                isError: true,
                callback: null,
            });
            console.error("Error updating anualidad", error);
        }
        finally {
            setLoading(false);
        }

    }

    const requestDeleteAnualidad = async (id) => {
        setLoading(true);
        try {
            const response = await deleteAnualidad(id);
            if (response.status === 200) {
                requestAnualidades();
                setInfoModal({
                    ...infoModal,
                    title: t('SUCCESS'),
                    message: t('SUCCESS_DELETE_ANNUALITY'),
                    isOpen: true,
                    isError: false,
                    callback: null,
                });
            }
        } catch (error) {
            const message = error.response && error.response.data && error.response.data.msg ? error.response.data.msg : "Error eliminando la anualidad";
            setInfoModal({
                ...infoModal,
                title: t('ERROR'),
                message: t('ERROR_DELETING_ANNUALITY'),
                isOpen: true,
                isError: true,
                callback: null,
            });
            console.error("Error deleting anualidad", error);
        } finally {
            setConfirmModal(defaultConfirmModal);
            setLoading(false);
        }
    }

    const renderCreateAnualidadModal = () => {
        return (
            <Modal
                isOpen={createModal}
                onClose={handleCloseModal}
                size="lg"
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {
                            idYear ? t('UPDATE_ANNUALITY') : t('CREATE_ANNUALITY')
                        }
                    </ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <div className="form-group">
                            <label htmlFor="dateCharge">{t('DATE')}</label>
                            <Input
                                id="dateCharge"
                                type="date"
                                value={dateCharge}
                                onChange={(e) => setDateCharge(e.target.value)}
                            />
                            {dateChargeError && <span className="text-danger">{dateChargeError}</span>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="year">{t('SELECTED_YEAR')}</label>
                            <Input
                                id="year"
                                type="text"
                                value={year}
                                disabled={true}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="monto">{t('AMOUNT')}</label>
                            <InputGroup>
                                <InputLeftAddon>$</InputLeftAddon>
                                <Input
                                    id="monto"
                                    type="text"
                                    value={monto}
                                    onChange={(e) => setMonto(e.target.value)}
                                    onBlur={checkInput.monto}
                                />
                            </InputGroup>
                            {montoError && <span className="text-danger">{montoError}</span>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="tipoCabana">{t('CABIN_TYPE')}</label>
                            <Select
                                id="tipoCabana"
                                options={tipoCabanaList}
                                value={tipoCabana}
                                onChange={(value) => setTipoCabana(value)}
                            />
                        </div>
                        <div style={{"textAlign": "right", marginTop: "20px", marginBottom: "20px"}}>
                            <Button
                                colorScheme="blue"
                                isLoading={loading}
                                loadingText="Guardando..."
                                isDisabled={loading}
                                onClick={idYear ? requestUpdateAnualidad :  requestCreateAnualidad}
                            >
                                {idYear ? t('UPDATE') : t('CREATE')}
                            </Button>
                        </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        )
    }

    useEffect(() => {
        requestAnualidades();
    }, [page]);

    useEffect(() => {
        console.log("Anualidades", anualidades);
    }, [anualidades]);

    useEffect(() => {
        if (dateCharge){
            const date = new Date(dateCharge.replace(/-/g, '/'));
            if(!isNaN(date)){
                setYear(date.getFullYear());
            }else{
                setYear("");
            }
        }
    }, [dateCharge]);

    return (
        <div className={"py-3 px-5"}>
            <Heading size={"lg"}>{t('ANNUALITIES')}</Heading>
            <div style={{width: '100%', textAlign: 'right'}}>
                <Button 
                    colorScheme="blue" 
                    my="4"
                    onClick={() => setCreateModal(true)}
                >
                    + {t('ADD_ANNUALITY')}
                </Button>
            </div>
            <div
                className="mt-1"
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                }}
            >
                <TableContainer>
                    <Table variant="simple">
                        <Thead>
                            <Tr>
                                <Th>{t('CABIN_TYPE')}</Th>
                                <Th>{t('YEAR')}</Th>
                                <Th>{t('AMOUNT')}</Th>
                                <Th>{t('DATE_ADDED')}</Th>
                                <Th></Th>
                                <Th></Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                anualidades.map((anualidad, ix) => (
                                    <Tr key={ix}>
                                        <Td>{anualidad.tipoCabana}</Td>
                                        <Td>{anualidad.year}</Td>
                                        <Td>{anualidad.monto}</Td>
                                        <Td>{anualidad.fecha ? anualidad.fecha.split("T")[0] : ""}</Td>
                                        <Td>
                                            <Button
                                                colorScheme="blue"
                                                onClick={() => {
                                                    setIdYear(anualidad.id);
                                                    setDateCharge(anualidad.fecha.split("T")[0]);
                                                    setYear(anualidad.year);
                                                    setMonto(anualidad.monto);
                                                    setTipoCabana(tipoCabanaList.find(itm => itm.value === anualidad.tipoCabana));
                                                    setCreateModal(true);
                                                }}
                                            >
                                                {t('EDIT')}
                                            </Button>
                                        </Td>
                                        <Td>
                                            <Button
                                                colorScheme="red"
                                                onClick={() => {
                                                    setConfirmModal({
                                                        title: t('DELETE_ANNUALITY'),
                                                        message: t('CONFIRM_DELETE_ANNUALITY'),
                                                        isOpen: true,
                                                        onConfirm: () => {
                                                            requestDeleteAnualidad(anualidad.id);
                                                        },
                                                        onClose: () => setConfirmModal(defaultConfirmModal),
                                                        isLoading: loading,
                                                        id: anualidad.id,
                                                    });
                                                }}
                                            >
                                                {t('DELETE')}
                                            </Button>
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            {
                renderCreateAnualidadModal()
            }
            <InfoModal
                title={infoModal.title}
                message={infoModal.message}
                isOpen={infoModal.isOpen}
                onClose={() => {
                    setInfoModal(defaultInfoModal);
                }}
                isError={infoModal.isError}
                callback={infoModal.callback}
            />
            <ConfirmModal
                title={confirmModal.title}
                message={confirmModal.message}
                isOpen={confirmModal.isOpen}
                onClose={() => {
                    setConfirmModal(defaultConfirmModal);
                }}
                onConfirm={confirmModal.onConfirm}
                isLoading={loading}
            />
            <Pagination
                pageCount={totalPages}
                currentPage={page}
                onPageChange={(selectedPage) => setPage(selectedPage)}
            />
        </div>
    )
}

export default Anualidad;